import { StreakCompletionResult } from './user_streak';
export class SaveUserWeightResult {
    constructor(data, config) {
        Object.defineProperty(this, "showGoalAchievedDialog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.showGoalAchievedDialog = data.showGoalAchievedDialog;
        this.streakCompletionResult = data.streakCompletionResult
            ? new StreakCompletionResult(data.streakCompletionResult, config)
            : null;
    }
}
